"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var Bell = function (_a) {
    var _b = _a.color, color = _b === void 0 ? helios_styles_1.icon.default : _b, _c = _a.size, size = _c === void 0 ? 24 : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, fill: "none", viewBox: "4 4 22 22" }, { children: (0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", d: "M11.05 7.05A7 7 0 0 1 23 12c0 3.353.717 5.435 1.378 6.646.332.608.655 1.008.88 1.244a3 3 0 0 0 .305.284q.003 0 .003.002A1 1 0 0 1 25 22H7a1 1 0 0 1-.563-1.826l.052-.042c.053-.044.141-.123.254-.242.224-.236.547-.636.88-1.244C8.282 17.435 9 15.353 9 12a7 7 0 0 1 2.05-4.95M9.15 20h13.702a9 9 0 0 1-.229-.396C21.782 18.065 21 15.647 21 12a5 5 0 0 0-10 0c0 3.647-.783 6.065-1.622 7.604q-.114.21-.229.396m4.62 4.135a1 1 0 0 1 1.366.363 1 1 0 0 0 1.73 0 1 1 0 0 1 1.73 1.004 3 3 0 0 1-5.19 0 1 1 0 0 1 .363-1.367", clipRule: "evenodd" }) })));
};
exports.Bell = Bell;
